module.exports = "<div class=\"\" ng-transclude></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpAllErrorsList/adpAllErrorsList.html
// module id = 687
// module chunks = 0